import { STATS } from '../../data/mock';

export default function SocialProof() {
  return (
    <section className="py-20 lg:py-28 bg-ivory">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-12 lg:mb-16 reveal">
          <p className="text-[11px] tracking-[0.3em] uppercase text-champagne-deep mb-6">Social Proof</p>
          <h2 className="font-serif text-4xl lg:text-6xl leading-[1.05] text-charcoal">
            A practice built on <em className="italic-accent">real outcomes.</em>
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-charcoal/10 reveal">
          {STATS.map((s) => (
            <div key={s.label} className="bg-ivory p-8 lg:p-10">
              <p className="font-display text-3xl lg:text-5xl text-charcoal leading-none">{s.value}</p>
              <p className="mt-4 text-[10px] tracking-[0.28em] uppercase text-champagne-deep leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
